<template>
  <b-card no-body class="pt-2 pb-2 card-create">
    <b-row v-if="!loadingMappingBanner">
      <b-col
        cols="12"
        class="d-flex justify-content-end px-3"
        v-if="!setMappingBannerTable.payload.length == 0"
      >
        <add-button btn-label="Add" @click.native="openMappingModal" />
      </b-col>
      <b-col v-if="setMappingBannerTable.payload.length == 0" cols="12">
        <content-no-item :textNoImg="'Add'" :actionFunc="openMappingModal" />
      </b-col>
      <b-col v-else cols="12">
        <b-row>
          <b-col cols="12" class="d-flex justify-content-end my-1 px-3">
            <div class="search-mapping-banner-container">
              <search :on-search-input="onSearch" />
            </div>
          </b-col>
          <b-col cols="12">
            <b-table
              :fields="fields"
              :items="setMappingBannerTable.payload"
              :per-page="pagination.perPage"
              :total-rows="pagination.rows"
              :current-page="pagination.currentPage"
              :filter="searchValue.query"
              responsive
              bordered
              borderless
              sticky-header
              class="set-mapping-table"
              v-sortable-row="sortableRowOptions"
              :class="!sortableRowOptions.disabled ? 'reorder' : null"
              :key="tableModeReorder + keyChange"
            >
              <template #cell(no)="data">
                <span>{{ data.index + 1 }}</span>
              </template>
              <template #cell(banner_image_url)="data">
                <div v-if="data.item.banner_image_url" class="col-img">
                  <img
                    class="mapping-banner-img"
                    :src="data.item.banner_image_url"
                    alt=""
                    draggable="false"
                  />
                </div>
                <div v-else class="text-center">
                  -
                </div>
              </template>
              <template #cell(set_name)="data">
                <div :class="data.item.set_name ? null : 'text-center'">
                  {{ data.item.set_name || "-" }}
                </div>
              </template>
              <template #cell(banner_name)="data">
                <div :class="data.item.banner_name ? null : 'text-center'">
                  {{ data.item.banner_name || "-" }}
                </div>
              </template>
              <template #cell(call_to_action)="data">
                <div :class="data.item.call_to_action ? null : 'text-center'">
                  {{ data.item.call_to_action || "-" }}
                </div>
              </template>
              <template #cell(valid_from)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_from)
                }}</span>
              </template>
              <template #cell(valid_through)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_through)
                }}</span>
              </template>
              <template #cell(latest_update)="data">
                <span>{{
                  data.item.update_time
                    ? resolveDateWithSeperator(data.item.update_time)
                    : resolveDateWithSeperator(data.item.updated_time)
                }}</span>
              </template>
              <template #cell(status)="data">
                <div
                  v-if="data.item.status || data.item.banner_status == 'Active'"
                  class="d-flex align-items-center"
                >
                  <feather-icon icon="CircleIcon" class="active-icon mr-2" />

                  <span>
                    {{
                      data.item.banner_status ||
                        resolveBannerStatusLabel(data.item.status)
                    }}
                  </span>
                </div>
                <div v-else class="d-flex align-items-center">
                  <feather-icon icon="CircleIcon" class="inActive-icon mr-2" />
                  <span class="inActive-label">
                    {{
                      data.item.banner_status ||
                        resolveBannerStatusLabel(data.item.status)
                    }}
                  </span>
                </div>
              </template>
              <template #cell(actions)="data">
                <action-group
                  :resolveAction="resolveBannerAction"
                  :setActionList="setBannerGroupActionList"
                  :itemData="data"
                />
                <!-- <div class="d-flex justify-content-center">
                  <b-button
                    v-b-tooltip.hover
                    variant="secondary"
                    class="banner-action mr-2"
                    title="Edit"
                    @click="onEditMappingBanner(data.item)"
                  >
                    <edit-icon class="banner-group-action-svg iconEdit-btn" />
                  </b-button>
                  <b-button
                    v-b-tooltip.hover
                    variant="secondary"
                    class="banner-action mr-2"
                    title="Delete"
                    @click="onRemoveMappingBanner(data.item)"
                  >
                    <delete-icon class="banner-group-action-svg" />
                  </b-button>
                </div> -->
              </template>
            </b-table>
          </b-col>
          <b-col cols="12" class="px-3">
            <pagination-with-reorder
              reordering
              entity-editable
              :pagination="pagination"
              @reorder="handleTableReorder"
              @entityChange="onFilterEntity"
              @pageChange="onPageChange"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-else>
      <!-- <b-col cols="12" class="loading-mapping-banner-table">
        <b-spinner class="loading-mapping-banner-spinner" />
      </b-col> -->
      <overlay-loading :loading="true" />
    </b-row>
    <mapping-banner-modal
      v-if="modalType.mapping"
      :mapping-list="setMappingBannerTable.payload"
      @onCloseModal="closeMappingModal"
    />
    <reorder-modal
      v-if="modalType.reorder"
      :currentIndex="indexReorder"
      :reorderAction="reorderBanner"
      @onCloseModal="resolveCloseModalAction(setBannerGroupActionList.reorder)"
    />
  </b-card>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BCard,
  BButton,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BSpinner,
} from "bootstrap-vue";
import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import KebabIcon from "@/@core/components/svg/common/Kebeb.vue";
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import DeleteIcon from "@/@core/components/svg/common/Trash.vue";
import SaveButton from "@/views/components/button/SaveButton.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import CardNoItem from "@/@core/components/card-no-item/CardNoItem.vue";
import MappingBannerModal from "./MappingBannerModal.vue";
import useCreateMappingBanner from "../hooks/useCreateMappingBanner";
import ContentNoItem from "@/@core/components/card-no-item/ContentNoItem.vue";

import ReorderButton from "@/views/components/button/ReorderButton.vue";
import ReorderModal from "@core/components/reorder-modal/ReorderModal.vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import Sortable from "sortablejs";

const createSortable = (el, options, vnode) => {
  return Sortable.create(el, {
    ...options,
  });
};

const sortableRow = {
  name: "sortableRow",
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },
};

export default {
  directives: {
    sortableRow,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BButton,
    BDropdown,
    BDropdownItem,
    BSpinner,
    BFormCheckbox,
    AddButton,
    Search,
    KebabIcon,
    EditIcon,
    DeleteIcon,
    SaveButton,
    MappingBannerModal,
    PaginationWithReorder,
    CardNoItem,
    ContentNoItem,
    ReorderButton,
    ReorderModal,
    ActionGroup,
  },

  props: {
    mappingBanner: Array,
    loadingMappingBanner: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },

  setup(props) {
    const {
      fields,
      setMappingBannerTable,
      pagination,
      searchValue,
      resolveDateWithSeperator,
      resolveBannerStatusLabel,
      resolveBannerAction,
      closeMappingModal,
      openMappingModal,
      onPageChange,
      onSearch,
      resolveDeleteAction,
      setBannerGroupActionList,
      tableModeReorder,
      handleTableReorder,
      resolveCloseModalAction,
      modalType,
      indexReorder,
      reorderBanner,
      onFilterEntity,
      sortableRowOptions,
      keyChange,
    } = useCreateMappingBanner(props);

    return {
      fields,
      setMappingBannerTable,
      pagination,
      searchValue,
      resolveDateWithSeperator,
      resolveBannerStatusLabel,
      resolveBannerAction,
      closeMappingModal,
      openMappingModal,
      onPageChange,
      onSearch,
      resolveDeleteAction,
      setBannerGroupActionList,
      tableModeReorder,
      handleTableReorder,
      resolveCloseModalAction,
      modalType,
      indexReorder,
      reorderBanner,
      onFilterEntity,
      sortableRowOptions,
      keyChange,
    };
  },
};
</script>

<style></style>

<style scoped>
@import "~@/assets/css/pages/banner/set-mapping-banner.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";
</style>
